// extracted by mini-css-extract-plugin
export var createdDate = "_i5-1";
export var divider = "_i5-2";
export var headerDivider = "_i5-3";
export var messagesCard = "_i5-0";
export var messagesContainer = "_i5-6";
export var messagesContainerWrapper = "_i5-4";
export var showLeftPanelButton = "_i5-8";
export var topButtons = "_i5-7";
export var withPadding = "_i5-5";